(() => {
  const selector = "[data-product-performance-specs]";
  const initializedFlag = "ppsReady";
  const animatedFlag = "ppsAnimated";

  const isReducedMotion = () =>
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const prepareMeterFills = (section) => {
    section.querySelectorAll(".pps__meter-fill").forEach((fill) => {
      if (!fill.dataset.targetWidth) {
        fill.dataset.targetWidth = fill.style.width || "0%";
      }
      fill.style.width = isReducedMotion() ? fill.dataset.targetWidth : "0%";
    });
  };

  const prepareTemperatureOrnaments = (section) => {
    section
      .querySelectorAll(".pps__temperature-ornament svg path, .pps__temperature-ornament svg circle")
      .forEach((shape) => {
        const length = shape.getTotalLength();
        shape.style.strokeDasharray = `${length}`;
        shape.style.strokeDashoffset = isReducedMotion() ? "0" : `${length}`;
      });
  };

  const animate = (section) => {
    if (!section || section.dataset[animatedFlag] === "true") {
      return;
    }

    section.dataset[animatedFlag] = "true";
    section.classList.add("pps--animated");

    section.querySelectorAll(".pps__meter-fill").forEach((fill) => {
      fill.style.width = fill.dataset.targetWidth || fill.style.width || "0%";
    });

    section
      .querySelectorAll(".pps__temperature-ornament svg path, .pps__temperature-ornament svg circle")
      .forEach((shape) => {
        shape.style.strokeDashoffset = "0";
      });
  };

  const observeAndAnimate = (section) => {
    if (!section) {
      return;
    }

    if (isReducedMotion() || !("IntersectionObserver" in window)) {
      animate(section);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animate(section);
            observer.unobserve(section);
          }
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(section);
  };

  const init = (section) => {
    if (!section || section.dataset[initializedFlag] === "true") {
      return;
    }

    section.dataset[initializedFlag] = "true";
    section.classList.add("pps--ready");
    prepareMeterFills(section);
    prepareTemperatureOrnaments(section);
    observeAndAnimate(section);
  };

  const run = () => {
    document.querySelectorAll(selector).forEach(init);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target?.querySelector(selector) || event.target);
  });
})();
